import { getValidationsErrorsConfig } from '@repo/catalogs-services'
import { defineSagaForService } from '@repo/core'
import {
  accountsValidationsErrorsActions,
  commonValidationsErrorsActions,
  mailboxValidationsErrorsActions,
  positionValidationsErrorsActions,
  toolsValidationsErrorsActions,
  userValidationsErrorsActions,
} from '../../slices'
import { createConfig } from '../generators'

export const loadValidationsErrorsServiceConfig = defineSagaForService({
  [accountsValidationsErrorsActions.getRequest.type]: createConfig(
    accountsValidationsErrorsActions.getResponse,
    getValidationsErrorsConfig,
    accountsValidationsErrorsActions.getRequest,
  ),
  [positionValidationsErrorsActions.getRequest.type]: createConfig(
    positionValidationsErrorsActions.getResponse,
    getValidationsErrorsConfig,
    positionValidationsErrorsActions.getRequest,
  ),
  [toolsValidationsErrorsActions.getRequest.type]: createConfig(
    toolsValidationsErrorsActions.getResponse,
    getValidationsErrorsConfig,
    toolsValidationsErrorsActions.getRequest,
  ),
  [commonValidationsErrorsActions.getRequest.type]: createConfig(
    commonValidationsErrorsActions.getResponse,
    getValidationsErrorsConfig,
    commonValidationsErrorsActions.getRequest,
  ),
  [userValidationsErrorsActions.getRequest.type]: createConfig(
    userValidationsErrorsActions.getResponse,
    getValidationsErrorsConfig,
    userValidationsErrorsActions.getRequest,
  ),
  [mailboxValidationsErrorsActions.getRequest.type]: createConfig(
    mailboxValidationsErrorsActions.getResponse,
    getValidationsErrorsConfig,
    mailboxValidationsErrorsActions.getRequest,
  ),
})
